// Tech Documentation Multi-Agent Models

export interface MultiTechDocRequest {
  subject: string;
  docType?: string;
  technicalLevel?: string;
  targetAudience?: string;
  keySections?: string[];
  includeExamples?: boolean;
  maxTokensPerAgentTurn?: number;
}

export interface MultiTechDocResponse {
  finalDocument?: string;
}

export interface TechDocSession {
  id: string;
  subject: string;
  docType?: string;
  technicalLevel?: string;
  targetAudience?: string;
  keySections?: string[];
  finalDocument?: string;
  createdAt: Date;
  includeExamples?: boolean;
}

export interface TechDocSessionStorage {
  sessions: TechDocSession[];
  lastUpdated: Date;
}

// Common doc types for UI suggestions
export const DOC_TYPES = [
  'API Documentation',
  'User Guide',
  'Installation Guide',
  'Configuration Guide',
  'Architecture Documentation',
  'Tutorial',
  'Reference Manual',
  'Quick Start Guide',
  'Troubleshooting Guide',
  'Best Practices Guide',
  'Release Notes',
  'Technical Specification'
];

// Technical levels for UI
export const TECHNICAL_LEVELS = [
  'Beginner',
  'Intermediate', 
  'Advanced',
  'Expert'
];

// Common sections for suggestions
export const COMMON_SECTIONS = [
  'Introduction',
  'Prerequisites',
  'Installation',
  'Configuration',
  'Getting Started',
  'API Reference',
  'Examples',
  'Best Practices',
  'Troubleshooting',
  'FAQ',
  'Glossary',
  'Appendix'
];